import Loader from "components/shared/loader";
import React, { Component } from "react";

export default class ProfileTabTemplate extends Component {
    initialState = {};

    state = {
        isLoading: true,
        shouldUpdate: false,
    };

    componentDidMount() {
        this.setState({ isLoading: false, ...this.initialState });
    }

    renderBody = () => {
        return null;
    };

    updateToggle = (val) => {
        this.setState({ shouldUpdate: !!val });
    };

    render() {
        return (
            <div className="profile__tab-wrapper">
                {this.state.isLoading ? <Loader prefix="absolute-center" /> : this.renderBody()}
            </div>
        );
    }
}
